export default __webpack_public_path__ + "assets/images/New-Experience-404347434263cad08242db1b43db08eb.svg";